import { useCallback } from 'react'

import EditIcon from '@/assets/icons/icon-edit.svg'
import { Button } from '@/components/ui/button.tsx'
import type { RestrictedWord } from '@/modules/restricted-words/types.ts'
import { classNames } from '@/utils/helpers.ts'

interface Props {
  item: RestrictedWord
  onEditClick: (item: RestrictedWord) => void
  isSelectionOpen: boolean
  isSelected: boolean
  onSelect: (item: RestrictedWord) => void
}

export const RestrictedWordsItem = ({
  item,
  onEditClick,
  isSelectionOpen,
  onSelect,
  isSelected,
}: Props) => {
  const { disabled, common, word } = item

  const handleEditClick = useCallback(() => {
    onEditClick(item)
  }, [item, onEditClick])

  const handleClick = useCallback(() => {
    if (isSelectionOpen) {
      onSelect(item)
    }
  }, [isSelectionOpen, item, onSelect])

  return (
    <div
      className={classNames(
        'group relative flex h-[62px] items-center justify-center rounded bg-secondary-50 text-sm font-medium dark:bg-secondary-600',
        {
          'bg-white text-secondary-200 dark:bg-secondary-700 dark:text-secondary-400':
            disabled,
          'border border-border-secondary': disabled && !isSelected,
          'bg-[#E2F0FE] dark:bg-primary-900': !common,
          'cursor-pointer': isSelectionOpen,
          'border-0.5 border border-primary-500': isSelected,
        },
      )}
      onClick={handleClick}
    >
      <span
        title={word}
        className={classNames(
          'block max-w-[calc(100%-8px)] overflow-hidden overflow-ellipsis whitespace-nowrap',
          {
            'group-hover:opacity-70': !isSelectionOpen,
          },
        )}
      >
        {word}
      </span>
      {!isSelectionOpen && (
        <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-primary-500 opacity-0 transition-opacity group-hover:opacity-80 dark:bg-primary-900">
          <Button
            onClick={handleEditClick}
            variant="ghost"
          >
            <EditIcon className="text-white" />
          </Button>
        </div>
      )}
    </div>
  )
}
